import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-column pl-2 pr-2" }
const _hoisted_2 = { class: "mt-2 mb-2 flex align-items-center flex-column md:justify-content-between md:flex-row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "" }, "BALÍKY PRODUKTOV", -1)
const _hoisted_4 = { class: "flex align-items-center" }
const _hoisted_5 = { class: "p-1" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "text-green-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Column = _resolveComponent("Column")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/mod-stock/packages/0",
            class: "mr-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PrimevueButton, {
                label: "Pridať balík",
                severity: "success",
                icon: "pi pi-plus",
                text: "",
                raised: "",
                class: "uppercase"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/mod-stock/scan-item",
            class: "mr-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PrimevueButton, {
                label: "Skenovať balík",
                severity: "success",
                icon: "pi pi-camera",
                text: "",
                raised: "",
                class: "uppercase"
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_DataTable, {
        lazy: "",
        paginator: "",
        rows: this.pagination.rows,
        onPage: $options.onPage,
        first: this.pagination.first,
        loading: $data.loading,
        totalRecords: this.pagination.totalRecords,
        dataKey: "id",
        value: this.packages,
        filters: $data.filters,
        "onUpdate:filters": _cache[0] || (_cache[0] = ($event: any) => (($data.filters) = $event)),
        onFilter: $options.onFilter,
        filterDisplay: "row",
        globalFilterFields: $data.globalFilterFields,
        stripedRows: "",
        "row-hover": "",
        scrollable: "",
        selection: this.selectedPackage,
        "onUpdate:selection": _cache[1] || (_cache[1] = ($event: any) => ((this.selectedPackage) = $event)),
        selectionMode: "single",
        metaKeySelection: false,
        tableStyle: "min-width: 10rem",
        virtualScrollerOptions: { itemSize: 40 },
        scrollHeight: `${this.vh - 420}px`,
        expandedRows: $data.expandedRows,
        "onUpdate:expandedRows": _cache[2] || (_cache[2] = ($event: any) => (($data.expandedRows) = $event))
      }, {
        expansion: _withCtx((slotProps) => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_DataTable, {
              value: slotProps.data.packages
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Column, { header: "" }, {
                  body: _withCtx((slotProps) => [
                    _createElementVNode("img", {
                      src: `${slotProps.data.product.image}`,
                      alt: slotProps.data.product.image,
                      class: "shadow-4 border-round",
                      width: "64"
                    }, null, 8, _hoisted_6)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_Column, {
                  field: "product.category.name",
                  header: "Kategória",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "product.code",
                  header: "Kód",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "product.name",
                  header: "Názov",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "product.length",
                  header: "Dĺžka"
                }),
                _createVNode(_component_Column, {
                  field: "numberOfPieces",
                  header: "Počet kusov",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "numberOfReservedPieces",
                  header: "Rezerv."
                }),
                _createVNode(_component_Column, {
                  field: "numberOfFreePieces",
                  header: "Voľné",
                  sortable: ""
                }, {
                  body: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(slotProps.data.numberOfFreePieces), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["value"])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            expander: "",
            style: {"width":"1rem"}
          }),
          _createVNode(_component_Column, {
            header: "",
            style: {"min-width":"1%"}
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("div", {
                class: "color-box",
                style: _normalizeStyle({ backgroundColor: slotProps.data.color.colorHash })
              }, null, 4)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "code",
            header: "Kód"
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.code), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "codes",
            header: "Produkty"
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.listOfProd), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "numberOfPieces",
            header: "Počet kusov"
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.numberOfPieces), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "numberOfReservedPieces",
            header: "Rezerv."
          }),
          _createVNode(_component_Column, {
            field: "location",
            header: "Umiestnenie",
            filterField: "location",
            showFilterMenu: false,
            filterMenuStyle: { width: '2rem' },
            style: {"min-width":"2%"}
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.location), 1)
            ]),
            filter: _withCtx(({ filterModel, filterCallback }) => [
              _createVNode(_component_InputText, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                type: "text",
                onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
                class: "p-column-filter",
                placeholder: "Hľadať",
                style: {"min-width":"2%"}
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "" }, {
            body: _withCtx((slotProps) => [
              _withDirectives(_createVNode(_component_PrimevueButton, {
                type: "button",
                icon: "pi pi-pencil",
                class: "pack",
                onClick: ($event: any) => ($options.showDetail(slotProps.data.id)),
                text: "",
                size: "small"
              }, null, 8, ["onClick"]), [
                [
                  _directive_tooltip,
                  { value: 'Editácia balíka' },
                  void 0,
                  { top: true }
                ]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "" }, {
            body: _withCtx((slotProps) => [
              _withDirectives(_createVNode(_component_PrimevueButton, {
                type: "button",
                icon: "pi pi-trash",
                class: "pack",
                onClick: ($event: any) => ($options.confirmDelete(slotProps.data.id)),
                text: "",
                severity: "danger",
                size: "small"
              }, null, 8, ["onClick"]), [
                [
                  _directive_tooltip,
                  { value: 'Vymazanie balíka' },
                  void 0,
                  { top: true }
                ]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["rows", "onPage", "first", "loading", "totalRecords", "value", "filters", "onFilter", "globalFilterFields", "selection", "scrollHeight", "expandedRows"])
    ]),
    _createVNode(_component_ConfirmDialog)
  ], 64))
}